import ConnectionStatus from './ConnectionStatus'
import connect from './connect';

export default connect(ConnectionStatus);



// WEBPACK FOOTER //
// ./src/components/ConnectionStatus/index.js